<template lang="pug">
.order-refund
  el-row.header
    el-col.text-c(:span="4") 商品
    el-col.text-c(:span="2") 单价
    el-col.text-c(:span="2") 数量
    el-col.text-c(:span="2") 重量
    el-col.text-c(:span="2") 交易金额
    el-col.text-c(:span="2") 退款金额
    el-col.text-c(:span="4") 买家信息
    el-col.text-c(:span="2") 退款状态
    el-col.text-c(:span="2") 退款原因
    el-col.text-c(:span="2") 操作
  .title
    span 退款编号：
    span.order-num {{refundList[0] && refundList[0].id}}
    span.ml-20 申请时间：
    time {{bizOrder.createTime | dataFormat}}
    span.ml-20  订单编号：
    span.order-num {{bizOrder.bizOrderId}}
    span.ml-20 退款类型：
    span(v-if="refundList[0] && refundList[0].refundType === 1") 退款
    span(v-if="refundList[0] && refundList[0].refundType === 2") 退款退货
    span(v-if="refundList[0] && refundList[0].refundType === 3") 全部退货退款

  ul
    li(v-for="item, index in refundList" :key="index")
      el-row(align="middle" type="flex")
        el-col.pl-8(:span="4")
          .goods-name {{item.itemTitle}}
          .goods-info 商品编号:{{item.itemId}}
          .goods-info 商品属性:{{item.detailItemInfo.skuTitle}}
        el-col.text-c.p-10-0(:span="2")
          template(v-if="bizOrder.logisticsPrice || bizOrder.processFee || bizOrder.storageFee || bizOrder.commissionFee || bizOrder.promiseInterestSubsidyFee || bizOrder.settleAdjustFee")
            p {{ (orderInfo.itemPrice + bizOrder.logisticsPrice + (bizOrder.processFee || 0) + (bizOrder.storageFee || 0) + (bizOrder.commissionFee || 0) + (bizOrder.promiseInterestSubsidyFee || 0) + (bizOrder.settleAdjustFee || 0)) | currencyFormat }}
              zg-info
                div(slot="content")
                  div 商品单价：{{ orderInfo.itemPrice | currencyFormat }}/{{bizOrder.pieceWeightUnit | formatWeightUnit}}
                  div(v-if='bizOrder.logisticsPrice') 胖猫物流费：{{ bizOrder.logisticsPrice | currencyFormat }}/{{bizOrder.pieceWeightUnit | formatWeightUnit}}
                  div(v-if='bizOrder.processFee') 加工费：{{ bizOrder.processFee | currencyFormat }}/{{bizOrder.pieceWeightUnit | formatWeightUnit}}
                  div(v-if='bizOrder.storageFee') 仓储费：{{ bizOrder.storageFee | currencyFormat }}/{{bizOrder.pieceWeightUnit | formatWeightUnit}}
                  div(v-if='bizOrder.commissionFee') 委托物流费：{{ bizOrder.commissionFee | currencyFormat }}/{{bizOrder.pieceWeightUnit | formatWeightUnit}}
                  div(v-if='bizOrder.promiseInterestSubsidyFee') 承兑贴息费：{{ bizOrder.promiseInterestSubsidyFee | currencyFormat }}/{{bizOrder.pieceWeightUnit | formatWeightUnit}}
                  div(v-if='bizOrder.settleAdjustFee') 结算调差费：{{ bizOrder.settleAdjustFee | currencyFormat }}/{{bizOrder.pieceWeightUnit | formatWeightUnit}}

          template(v-else)
            p {{ orderInfo.itemPrice | currencyFormat }}
        el-col.text-c.p-10-0(:span="2") {{item.refundQuality}}
        el-col.text-c.p-10-0(:span="2") {{item.refundWeightStr/10000}}{{getWeightUnit(item.detailItemInfo.pieceWeightUnit)}}
        el-col.text-c.p-10-0(:span="2")
          p {{bizOrder.actualTotalFee | currencyFormat}}
            zg-info(v-if="bizOrder.logisticsTotalFee || bizOrder.processTotalFee || bizOrder.storageTotalFee || bizOrder.commissionTotalFee || bizOrder.promiseInterestSubsidyTotalFee || bizOrder.settleAdjustTotalFee")
              div(slot="content")
                div 商品金额：{{ bizOrder.obligationTotalFee | currencyFormat }}
                div(v-if="bizOrder.logisticsTotalFee") 胖猫物流费金额：{{ bizOrder.logisticsTotalFee | currencyFormat }}
                div(v-if="bizOrder.processTotalFee") 加工费金额：{{ bizOrder.processTotalFee | currencyFormat }}
                div(v-if="bizOrder.storageTotalFee") 仓储费金额：{{ bizOrder.storageTotalFee | currencyFormat }}
                div(v-if="bizOrder.commissionTotalFee") 委托物流费金额：{{ bizOrder.commissionTotalFee | currencyFormat }}
                div(v-if="bizOrder.promiseInterestSubsidyTotalFee") 承兑贴息金额：{{ bizOrder.promiseInterestSubsidyTotalFee | currencyFormat }}
                div(v-if="bizOrder.settleAdjustTotalFee") 结算调差金额：{{ bizOrder.settleAdjustTotalFee | currencyFormat }}
        el-col.text-c.p-10-0(:span="2") {{item.refundAmount | currencyFormat}}
        el-col.pl-8(:span="4")
          .buyer-info {{bizOrder.buyerOrgName}}
          .buyer-info {{bizOrder.buyerNick}}
          .buyer-info {{bizOrder.buyerPhone | phoneFormat}}
        el-col.text-c.p-10-0(:span="2")
          .status(v-if="item.refundStatus === 1") 初始化状态
          .status(v-if="item.refundStatus === 2") 退款申请中
          .status(v-if="item.refundStatus === 3") 卖家同意
          .status(v-if="item.refundStatus === 4") 卖家不同意
          .status(v-if="item.refundStatus === 5") 退款成功
          .status(v-if="item.refundStatus === 6") 退款失败
        el-col.text-c.p-10-0(:span="2")
          el-button(type="text" @click="refundReason(item)") 查看原因
        el-col.text-c.p-10-0(:span="2" v-if="item.refundStatus === 2")
          el-button.button(type="text" @click="showRefundHint('confirm', item)") 同意
          br
          el-button.button(type="text" @click="showRefundHint('reject', item)") 拒绝

  el-dialog(:visible.sync="isShowRefundHint" :append-to-body="true" center title="退款申请")
    el-form(label-width="100px")
      el-form-item(label="退款金额：")
        span {{refundItem.refundAmount | currencyFormat}}
      el-form-item(label="退款原因：")
        span {{refundItem.refundReason}}
      el-form-item(label="驳回原因：" v-if="operateType === 'reject'")
        el-input(type="textarea" v-model="operateDescription")
      el-form-item(label="退款方式：" v-if="operateType === 'confirm'")
        span(v-if="refundItem.refundType === 3") 全部退款原路退回
        span(v-else) 线下交易
        //- el-select(v-model="refundWay" placeholder="选择退款方式")
        //-   el-option(v-for="item, index in refundWays" :key="index" :label="item.name" :value="item.value")
      el-form-item(label="退款凭证：" v-if="operateType === 'confirm' && refundItem.refundType !== 3")
        el-input(type="textarea" v-model="bankOrderId")
    .dialog-footer(slot="footer")
      el-button(@click="isShowRefundHint = false") 取 消
      el-button(@click="confirmRefundOperate" type="primary") 确 认

  el-dialog(:visible.sync="isShowRefundReason" :append-to-body="true" title="退款详情" center)
    el-form.border-b.mb-0(:model="refundItem" label-width="120px")
      el-form-item(label="退款类型：")
        span(v-if="refundItem.refundType === 1") 退款
        span(v-if="refundItem.refundType === 2") 退货
        span(v-if="refundItem.refundType === 3") 全部退货退款
      el-form-item(label="退款单号：")
        span {{refundItem.id}}
      el-form-item(label="申请时间：")
        span {{refundItem.gmtCreatedStr | dataFormat}}
      el-form-item(label="退款金额：")
        span {{refundItem.refundAmount | currencyFormat}}
      el-form-item(label="退款原因：")
        span {{refundItem.refundReason}}
    el-form.mb-0(:model="refundItem" v-if="refundItem.refundStatus > 2"  label-width="120px")
      el-form-item(label="退款状态：")
        span(v-if="refundItem.refundStatus === 1") 初始化状态
        span(v-if="refundItem.refundStatus === 2") 退款申请中
        span(v-if="refundItem.refundStatus === 3") 卖家同意
        span(v-if="refundItem.refundStatus === 4") 卖家不同意
        span(v-if="refundItem.refundStatus === 5") 退款成功
        span(v-if="refundItem.refundStatus === 6") 退款失败
      el-form-item(label="实际退款金额：")
        span {{refundItem.actualRefundAmount || 0 | currencyFormat}}
      el-form-item(label="操作时间：")
        span {{refundItem.feature | dataFormat}}

  refund-tenpay-qrcode(:visible.sync="tenpayRefundInfo.visible" :req-info="tenpayRefundInfo.reqInfo" :qrcode-info="tenpayRefundInfo.qrcodeInfo" @success="handleTenpayRefundSuccess")

</template>

<script>
import ZgInfo from '@/components/zg-info'
import RefundTenpayQrcode from './refund-tenpay-qrcode'
export default {
  name: 'refundItem',
  components: {
    ZgInfo,
    RefundTenpayQrcode
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      orderInfo: {} /** 交易订单基础信息 */,
      bizOrder: {} /** 交易订单基础信息 */,
      refundList: [] /** 退款数据列表 */,
      isShowRefundReason: false,
      isShowRefundHint: false,
      refundItem: {} /** 操作退款的数据 */,
      operateType: '' /** 操作退款类型   同意&拒绝 */,
      operateDescription: '' /** 拒绝退款的原因 */,
      refundWay: 1 /** 退款方式 */,
      bankOrderId: '' /** 退款凭证  银行流水号-全部退货退款不需要传 */,
      refundWays: [
        {
          name: '线下交易',
          value: 1
        },
        {
          name: '退回到余额',
          value: 2
        },
        {
          name: '全部退款原路退回',
          value: 3
        }
      ],
      tenpayRefundInfo: {
        visible: false,
        reqInfo: {
          sellerConfirmOrderRefundPara: null,
          id: null
        },
        qrcodeInfo: {
          expireTime: 0,
          qrCode: ''
        }
      }
    }
  },
  mounted() {
    this.orderInfo = this.item
    this.bizOrder = this.orderInfo && this.orderInfo.bizOrder
    this.getOrderRefundDetail()
    console.log(this.bizOrder.bizOrderId)
  },
  methods: {
    /** 通过子订单id和skuId获取退款子订单 */
    async getOrderRefundDetail() {
      try {
        const result = await this.$get('refund.getOrderRefundDetail', {
          getOrderRefundDetailPara: {
            orderDetailBizOrderId: this.bizOrder.bizOrderId,
            skuId: this.orderInfo.skuId
          }
        })
        if (result.success) {
          this.refundList = result.data[0].list
        }
      } catch (err) {
        console.log(err)
      }
    },
    /** 显示退款原因弹窗 */
    refundReason(item) {
      this.isShowRefundReason = true
      this.refundItem = item
    },
    /** 确认退款操作 */
    async confirmRefundOperate() {
      let sellerConfirmOrderRefundPara = {
        refundMainId: this.refundItem.refundMainId,
        refundDetailId: this.refundItem.id
      }
      if (this.operateType === 'reject') {
        sellerConfirmOrderRefundPara.operateDescription = this.operateDescription
        sellerConfirmOrderRefundPara.refundStatus = 4
      }
      if (this.operateType === 'confirm') {
        sellerConfirmOrderRefundPara.refundStatus = 3
        sellerConfirmOrderRefundPara.refundWay = this.refundWay
        if (this.refundItem.refundType !== 3) {
          sellerConfirmOrderRefundPara.bankOrderId = this.bankOrderId
        }
      }
      try {
        const result = await this.$post('refund.sellerConfirmOrderRefund', {
          sellerConfirmOrderRefundPara
        })
        if (result.data[0] && result.data[0].success) {
          if (result.data[0].qrCode) {
            this.isShowRefundHint = false
            this.tenpayRefundInfo.visible = true
            this.tenpayRefundInfo.qrcodeInfo.qrCode = result.data[0].qrCode
            this.tenpayRefundInfo.qrcodeInfo.expireTime = result.data[0].qrCode
            this.tenpayRefundInfo.reqInfo.sellerConfirmOrderRefundPara = sellerConfirmOrderRefundPara
            this.tenpayRefundInfo.reqInfo.id = this.refundItem.id
          } else {
            this.isShowRefundHint = false
            this.getOrderRefundDetail()
            this.$message.success('操作成功')
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    //财付通整单退款扫码成功
    handleTenpayRefundSuccess() {
      this.getOrderRefundDetail()
    },
    /** 显示退款弹窗 */
    showRefundHint(type, item) {
      this.isShowRefundHint = true
      this.operateType = type
      this.refundItem = item
    },
    getWeightUnit(type) {
      let out = '吨'
      if (type === 'KG') {
        out = '千克'
      }
      return out
    }
  }
}
</script>

<style lang="stylus" scoped>
.order-refund
  .el-button
    padding 4px

.header
  margin-bottom 20px

.text-c
  text-align center

.title
  background-color #f2f2f2
  height 40px
  line-height 40px
  padding 0 20px
  color #666
  font-size 14px

  .order-num
    color #319bf7

  .ml-20
    margin-left 20px

.border-l-b
  border-left 1px solid #dbdbdb
  border-bottom 1px solid #dbdbdb

.border-t-r
  border-top 1px solid #dbdbdb
  border-right 1px solid #dbdbdb


.p-10-0
  padding 10px 0

.pl-8
  padding 10px 0 10px 8px
  line-height 1.4

.border-b
  border-bottom 1px solid #dbdbdb

.mb-0
  .el-form-item
    margin-bottom 0

.status
  color #cd974c

.goods-name
  font-size 14px
  color #333
  width 100%
  line-height 1.4
  white-space normal
  overflow hidden
  text-overflow ellipsis
  display -webkit-box
  -webkit-line-clamp 2
  -webkit-box-orient vertical

.goods-info
  font-size 12px
  color #999
</style>
